// extracted by mini-css-extract-plugin
export default {"component":"StaffReportsRoutes_component__Wvvn6","darkMode":"StaffReportsRoutes_darkMode__RdPyd"};